import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { sendTemplate } from '../../../../actions/templates/templateSendModal'
import { ITemplate } from '../../../../models/Templates'
import { IStore } from '../../../../reducers'
import { mapEmailTemplateLabels } from '../../../../reducers/bookingCalendar/selectors/events'
import { getTemplates } from '../../../../reducers/templates/selectors/templates'
import { getSelectedLanguage } from '../../../../reducers/userAccount/selectors/userLanguage'
import closeModal from '../../../../actions/Modals/closeModal'
import {
  ISendEmailModalDispatch,
  ISendEmailModalProps,
} from './TemplateSendModal'

function mapStateToProps(state: IStore, ownProps): ISendEmailModalProps {
  const { event } = ownProps
  const mapLabels = event ? mapEmailTemplateLabels(state, { event }) : null

  return {
    email: ownProps.email || (event && event.guest && event.guest.email) || '',
    event: event,
    initialLanguage: getSelectedLanguage(state),
    mapLabels: mapLabels,
    templates: getTemplates(state),
  }
}

const bindDispatchToProps = (
  dispatch: Dispatch,
  ownProps,
): ISendEmailModalDispatch => ({
  close: () => dispatch(closeModal(ownProps.modalId)),
  onSend: (template: ITemplate) => dispatch(sendTemplate(template)),
})

export default connect(mapStateToProps, bindDispatchToProps)
